import React, { FC } from 'react';
import styled from 'styled-components';
import { WarningIcon } from '../Icons';
import { Tooltip } from '@mui/material';
import { IsMobileWidth } from '../MediaQueryUtils';

const Container = styled.div`
	display: flex;
	gap: 10px;
	padding: 10px;
	border-radius: 4px;
	border: 1.5px solid #f26184;
	background: #fef0f3;
	width: 100%;
	#infoWrapper {
		display: flex;
		flex-direction: column;
		width: 100%;
	}
`;
const InfoHeader = styled.div`
	p {
		color: #333;
		font-size: 14px;
		font-weight: 700;
	}
`;

const InfoMessageContainer = styled.div<{ btnStyles?: React.CSSProperties }>`
	display: flex;
	align-items: center;
	justify-content: space-between;
	color: #333;
	font-size: 14px;
	p {
		font-weight: 600;
	}
	div {
		${(props) => props?.btnStyles};
		font-weight: 700;
		text-decoration-line: underline;
		cursor: pointer;
	}
`;

interface WarningProps {
	onClick: any;
	message: string;
	btnStyles?: React.CSSProperties;
	tootip?: boolean;
	tooltipTitle?: string;
	style?: React.CSSProperties;
}

const Warning: FC<WarningProps> = ({
	onClick,
	message,
	btnStyles = { width: '135px' },
	tootip = false,
	tooltipTitle,
	style,
}) => {
	const isMobileWidth = IsMobileWidth();

	if (isMobileWidth) {
		return (
			<Container>
				<WarningIcon />
				<div id="infoWrapper">
					<InfoHeader>
						<p>Attention</p>
					</InfoHeader>
					<InfoMessageContainer
						style={{ flexDirection: 'column', gap: '10px', width: '100%' }}
						btnStyles={btnStyles}
					>
						<p>{message}</p>
						{tootip ? (
							<Tooltip title={tooltipTitle} placement="top">
								<div style={{ display: 'flex', justifyContent: 'flex-end' }} onClick={onClick}>
									Continue Anyway
								</div>
							</Tooltip>
						) : (
							<div style={{ display: 'flex', justifyContent: 'flex-end' }} onClick={onClick}>
								Continue Anyway
							</div>
						)}
					</InfoMessageContainer>
				</div>
			</Container>
		);
	}
	return (
		<Container>
			<WarningIcon />
			<div id="infoWrapper">
				<InfoHeader>
					<p>Attention</p>
				</InfoHeader>
				<InfoMessageContainer btnStyles={btnStyles}>
					<p>{message}</p>
					{tootip ? (
						<Tooltip title={tooltipTitle} placement="top">
							<div onClick={onClick}>Continue Anyway</div>
						</Tooltip>
					) : (
						<div onClick={onClick}>Continue Anyway</div>
					)}
				</InfoMessageContainer>
			</div>
		</Container>
	);
};

export default Warning;
